// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "measurequick.proto" (syntax proto3)
// tslint:disable
import { MeasureQuickService } from "./measurequick";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * MeasureQuick integration service. Authenticates to the MeasureQuick Partner API v1
 * (OAuth2 client_credentials), resolves the connected company, and maps Kalos
 * technicians to MeasureQuick technicians by email. Step 0 of the MeasureQuick
 * HVAC diagnostics integration.
 *
 * @generated from protobuf service MeasureQuickService
 */
export class MeasureQuickServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = MeasureQuickService.typeName;
        this.methods = MeasureQuickService.methods;
        this.options = MeasureQuickService.options;
    }
    /**
     * GetHealthStatus pings the MeasureQuick API and reports the connected company and
     * the current technician-mapping counts.
     *
     * @generated from protobuf rpc: GetHealthStatus
     */
    getHealthStatus(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * SyncTechnicians resolves the connected company and (re)builds the Kalos <-> MeasureQuick
     * technician map by matching emails, returning per-run counts.
     *
     * @generated from protobuf rpc: SyncTechnicians
     */
    syncTechnicians(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * DispatchServiceItem dispatches one specific system (service item) of a job to the assigned
     * technician's MeasureQuick Dispatched list. The explicit, per-system alternative to the
     * status-transition dispatch: reference_id is "{event}-{service_item}", so each system gets
     * its own card and the pulled report attaches to exactly that service item.
     *
     * @generated from protobuf rpc: DispatchServiceItem
     */
    dispatchServiceItem(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * BatchGetMeasureQuickReadings returns the structured readings parsed from MeasureQuick Pro
     * Reports, newest session first. Filter by service item (the system's history) and/or event
     * (one job's visits). Read-only: MeasureQuick is the source of truth for these values.
     *
     * @generated from protobuf rpc: BatchGetMeasureQuickReadings
     */
    batchGetMeasureQuickReadings(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * BatchGetMeasureQuickDispatches returns dispatch state for a service item and/or event, newest
     * first. Readings alone cannot distinguish "dispatched, waiting on the tech" from "never
     * dispatched" — both have zero readings — so a caller that wants to show a waiting state needs
     * this. Read-only.
     *
     * @generated from protobuf rpc: BatchGetMeasureQuickDispatches
     */
    batchGetMeasureQuickDispatches(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
